import { Layout, Menu } from 'antd';
import {
    DashboardOutlined,
    ShoppingCartOutlined,
    AppstoreOutlined,
    ShopOutlined,
    ThunderboltOutlined,
    SolutionOutlined,
    FileDoneOutlined,
    CarryOutOutlined,
    UsergroupAddOutlined,
    DollarCircleOutlined,
    FileSyncOutlined,
    RiseOutlined,
    BarChartOutlined,
    SettingOutlined,
} from '@ant-design/icons';


import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../assets/logo-pvs-profitpanels.png';

const { Sider } = Layout;

// Routes accessible by Officer (and Admin/Manager)
const OFFICER_KEYS = ['/', '/leads', '/customers', '/orders', '/reports/orders',
    '/channel-partners', '/inventory', 'sub-vendors', '/vendors', '/vendor-agreement',
    '/purchases', '/quotations', '/msedcl', '/payment-milestones', '/reports/warranty-certificate'];

// Routes accessible by Accounts (and Admin/Manager)
const ACCOUNTS_KEYS = ['/sales', '/proforma'];

const Sidebar = ({ collapsed, isMobile, setCollapsed }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const role = user.role || '';

    const allMenuItems = [
        {
            key: '/',
            icon: <DashboardOutlined />,
            label: 'Dashboard',
        },
        {
            key: '/leads',
            icon: <RiseOutlined />,
            label: 'Leads',
        },
        {
            key: '/customers',
            icon: <UsergroupAddOutlined />,
            label: 'Customers',
        },
        {
            key: '/orders',
            icon: <ShoppingCartOutlined />,
            label: 'Orders',
        },

        {
            key: '/channel-partners',
            icon: <SolutionOutlined />,
            label: 'Channel Partners',
        },
        {
            key: '/inventory',
            icon: <AppstoreOutlined />,
            label: 'Inventory',
        },
        {
            key: '/vendors',
            icon: <ShopOutlined />,
            label: 'Vendors',
        },
        {
            key: '/purchases',
            icon: <CarryOutOutlined />,
            label: 'Purchases',
        },
        {
            key: '/sales',
            icon: <FileDoneOutlined />,
            label: 'Sales Invoices',
        },
        {
            key: '/proforma',
            icon: <FileSyncOutlined />,
            label: 'Proforma Invoice',
        },

        {
            key: '/msedcl',
            icon: <ThunderboltOutlined />,
            label: 'MSEDCL Documents',
        },
        {
            key: '/payment-milestones',
            icon: <DollarCircleOutlined />,
            label: 'Payment Milestones',
        },
        {
            key: 'reports-section',
            icon: <BarChartOutlined />,
            label: 'Reports',
            children: [
                {
                    key: '/quotations',
                    label: 'Offer/Quotation',
                },
                {
                    key: '/vendor-agreement',
                    label: 'Vendor Consumer Agreement',
                },
                {
                    key: '/reports/orders',
                    label: 'Order Reports',
                },
                {
                    key: '/reports/warranty-certificate',
                    label: 'Warranty Certificate',
                },
            ]
        },
        {
            key: '/user-management',
            icon: <SettingOutlined />,
            label: 'User Management',
        },
    ];

    const menuItems = allMenuItems.filter((item) => {
        // Dashboard: always visible
        if (item.key === '/') return true;
        // User Management: Admin only
        if (item.key === '/user-management') return role === 'Admin';
        // Sales / Proforma: Admin, Manager, Accounts
        if (ACCOUNTS_KEYS.includes(item.key)) return ['Admin', 'Manager', 'Accounts'].includes(role);
        // Everything else: Admin, Manager, Officer
        return ['Admin', 'Manager', 'Officer'].includes(role);
    });

    const handleMenuClick = ({ key }) => {
        navigate(key);
        if (isMobile && setCollapsed) {
            setCollapsed(true);
        }
    };

    return (
        <Sider
            trigger={null}
            collapsible
            collapsed={collapsed}
            width={200}
            style={{
                overflow: 'auto',
                height: '100vh',
                position: isMobile ? 'static' : 'fixed',
                left: 0,
                top: 0,
                bottom: 0,
                backgroundColor: '#001529',
                zIndex: 10,
            }}
        >
            <div style={{
                width: collapsed ? '40px' : '64px',
                height: collapsed ? '40px' : '64px',
                margin: collapsed ? '16px auto' : '16px auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                transition: 'all 0.2s',
                background: 'white',
                borderRadius: '8px',
                padding: '4px'
            }}>
                <img
                    src={logo}
                    alt="Profit Panels Logo"
                    style={{
                        height: collapsed ? '40px' : '54px',
                        maxWidth: '100%',
                        objectFit: 'contain'
                    }}
                />
            </div>
            <Menu
                theme="dark"
                mode="inline"
                selectedKeys={[location.pathname]}
                items={menuItems}
                onClick={handleMenuClick}
            />
        </Sider>
    );
};

export default Sidebar;